import { Button, Typography } from '@hermes/web-components'
import useTranslateMessage from '@hooks/useTranslateMessage'
import { DoubleButtons } from '@components/BaseModal.styles'
import BaseModal from '@components/BaseModal'

import { AlertMessage } from './AlertsUnsubscribe.styles'

interface AlertsUnsubscribeProps {
  isOpen: boolean
  action: () => void
  onClose: () => void
}

const AlertsUnsubscribe = ({ isOpen, action, onClose }: AlertsUnsubscribeProps) => {
  const { t } = useTranslateMessage()
  return (
    <BaseModal isOpen={isOpen} width={400} onClose={onClose} title={t({ id: 'modal.unsubscribeFromAlerts.title' })}>
      <AlertMessage>
        <Typography>{t({ id: 'modal.unsubscribeFromAlerts.description' })}</Typography>
      </AlertMessage>
      <DoubleButtons>
        <Button onClick={onClose}>{t({ id: 'close' })}</Button>
        <Button onClick={action}>{t({ id: 'modal.unsubscribeFromAlerts.unsubscribe' })}</Button>
      </DoubleButtons>
    </BaseModal>
  )
}

export default AlertsUnsubscribe
